package com.vamvisions.main.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import androidx.lifecycle.ViewModelStore
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.viewModel
import org.koin.core.parameter.ParametersDefinition
import org.koin.mp.KoinPlatform

/**
 * Gives [content] its own ViewModelStore, identified by [scopeKey]. When the key changes (for
 * example, the user navigates to another route) or the scope leaves composition, the store is
 * cleared, which calls `onCleared` on its ViewModels.
 */
@Composable
fun ViewModelScope(scopeKey: Any, content: @Composable () -> Unit) {
    key(scopeKey) {
        val owner = remember {
            object : ViewModelStoreOwner {
                override val viewModelStore = ViewModelStore()
            }
        }
        DisposableEffect(owner) {
            onDispose { owner.viewModelStore.clear() }
        }
        CompositionLocalProvider(LocalViewModelStoreOwner provides owner) {
            content()
        }
    }
}

/**
 * Returns the [T] of the enclosing [ViewModelScope], creating it through Koin the first time, with
 * [parameters] when its definition takes any.
 */
@Composable
inline fun <reified T : ViewModel> koinViewModel(noinline parameters: ParametersDefinition? = null): T =
    viewModel { KoinPlatform.getKoin().get<T>(parameters = parameters) }
